import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import PopinContent from './PopinContent/PopinContent';

function Popin({ popinRef, isPopinOpen, setIsPopinOpen, view }) {
  // Création des fonctions permettant de gérer la fermeture de la popin
  const handleClosePopin = () => {
    // On ferme la modale
    if(popinRef.current) popinRef.current.close();

    // On met à jour l'état de la popin
    setIsPopinOpen(false);
  }

  // Mise en place des références pour cibler le premier élément du menu et le dernier
  // Et de la fonction permettant de réaliser le piège au clavier
  const firstButton = useRef(null);
  const lastButton = useRef(null);
  const handleKeyDown = (e, pos) => {
      if(isPopinOpen && pos === 'first' && e.keyCode === 9 && e.shiftKey === true && lastButton.current !== null) {
          e.preventDefault();
          lastButton.current.focus();
      }
      else if(isPopinOpen && pos === 'last' && e.keyCode === 9 && e.shiftKey === false && firstButton.current !== null) {
          e.preventDefault();
          firstButton.current.focus();
      }
  }

  // Gestion de la touche Echap pour fermer la popin
  useEffect(() => {
      // On créé la fonction de fermeture de la popin lors de l'appui sur la touche Echap
      const handleEscapeKey = (e) => {
          if (e.keyCode === 27 && isPopinOpen) {
            handleClosePopin();
          }
      }

      if (isPopinOpen) document.addEventListener("keydown", handleEscapeKey);

      return () => {
          document.removeEventListener("keydown", handleEscapeKey);
      };
  }, [isPopinOpen, handleClosePopin]);

  // Gestion de l'affichage de la popin
  useEffect(() => {
    if (isPopinOpen) {
      popinRef.current?.showModal();
      document.body.style.overflow = "hidden";
    } else {
      popinRef.current?.close();
      document.body.style.overflow = "";
    }

    return () => {
        document.body.style.overflow = "";
    }
  }, [popinRef, isPopinOpen]);

  // Définition du titre de la popin
  let popinTitle = '';
  let popinClasse = '';
  switch (view) {
    case 1:
      popinTitle = 'Le tuner';
      popinClasse = 'tuner';
      break;
    case 2:
      popinTitle = 'Le volume';
      popinClasse = 'volume';
      break;
    case 3:
      popinTitle = 'La tache';
      popinClasse = 'tache';
      break;
    case 4:
      popinTitle = 'Le choix des ondes';
      popinClasse = 'ondes';
      break;
    case 5:
      popinTitle = 'Le cadran des fréquences';
      popinClasse = 'frequences';
      break;
    case 6:
      popinTitle = "L'éraflure";
      popinClasse = 'eraflure';
      break;
    case 7:
      popinTitle = "L'anse de transport";
      popinClasse = 'anse';
      break;
    case 8:
      popinTitle = 'Le haut parleur';
      popinClasse = 'haut_parleur';
      break;
    case 9:
      popinTitle = 'Le revêtement';
      popinClasse = 'revetement';
      break;
  }

  // Déclaration de l'aria-label du bouton
  let buttonCloseAriaLabel = 'fermeture de la fenêtre interne';

  return (
    <dialog ref={popinRef} className={`popin popin--result popin--${popinClasse}`} aria-labelledby="popin-title">
      <h1 id="popin-title">{popinTitle}</h1>
      <button
          autoFocus
          className="button button-close button-close--popin-resultat"
          aria-label={buttonCloseAriaLabel}
          ref={firstButton}
          onClick={handleClosePopin}
          onKeyDown={(e) => handleKeyDown(e, 'first')}>
            <span className="sr-only">{buttonCloseAriaLabel}</span>
        </button>
      <PopinContent vid={view} handleClosePopin={handleClosePopin} buttonRef={lastButton} handleKeyDownFunc={(e) => handleKeyDown(e, 'last')} />
    </dialog>
  )
}

Popin.propTypes = {
  popinRef: PropTypes.object.isRequired,
  isPopinOpen: PropTypes.bool.isRequired,
  setIsPopinOpen: PropTypes.func.isRequired,
  view: PropTypes.object.isRequired
}

export default Popin;
